module.exports = __webpack_public_path__ + "europa-50-portrait_window.jpg?d180156a56a7a541de3a470f3b85c163";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50-portrait_window.jpg
// module id = 364
// module chunks = 0